var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-2 pt-2"},[_c('vx-tooltip',{attrs:{"text":_vm.tooltipText}},[_c('vs-chip',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.responsible))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }